// NIGHT-DIRECTSTAFF-2026-10-23c §5: placement nudges on Today.
//   Start day  a Confirmed placement (agreed, not started -- an accepted offer makes one) from its start date for up to 14 days:
//              "Did #35 start at Synthetic General?" [Started] [Not yet] (Not yet = done for today; it asks again tomorrow).
//   Ending     the "Placements ending soon" rows, 14 days or less before the end: "Ending soon -- re-placement started?" with the
//              re-placement agent's status, and [Open] the candidate.
import { daysTo, fmtDay } from './placements';

export const START_WINDOW_DAYS = 14;
export const REPLACEMENT_ASK_DAYS = 14;
const s = (v) => (v === null || v === undefined ? '' : String(v).trim());
const testTag = (c) => !!c && Array.isArray(c.tags) && c.tags.some((x) => s(x).toLowerCase() === 'test');

/** -> [{ placement, candidate, daysSince }] oldest start first; candidates not in the list (merged, test) are left out */
export function startChecks({ placements = [], candidates = [], now = Date.now() } = {}) {
  const byId = new Map((candidates || []).map((c) => [String(c.id), c]));
  const out = [];
  for (const p of placements || []) {
    if (s(p.status) !== 'confirmed' || !p.start_date) continue;
    const d = daysTo(p.start_date, now);
    if (d === null || d > 0 || -d > START_WINDOW_DAYS) continue;
    const candidate = byId.get(String(p.candidate_id));
    if (!candidate || testTag(candidate)) continue;
    out.push({ placement: p, candidate, daysSince: Math.abs(d) });   // d <= 0 here (never -0)
  }
  return out.sort((a, b) => s(a.placement.start_date).localeCompare(s(b.placement.start_date)));
}
/** "Did #35 start at Synthetic General? Start date Nov 9 (today)" */
export function startLine(x) {
  const when = x.daysSince === 0 ? 'today' : x.daysSince === 1 ? 'yesterday' : `${x.daysSince} days ago`;
  return `Did #${x.candidate.id} start at ${s(x.placement.facility) || 'the facility'}? Start date ${fmtDay(x.placement.start_date)} (${when})`;
}
/** The ending row's question, 14 days or less before the end; '' further out */
export function replacementAsk(x) {
  return x && x.days <= REPLACEMENT_ASK_DAYS ? `Ending soon — re-placement started? ${x.statusText}` : '';
}
/** "From offer 4 · …" in a placement's package note -> 4 (the offer link on the placement); null otherwise */
export const offerIdOf = (p) => { const m = /^From offer (\d+)\b/.exec(s(p && p.package_note)); return p && s(p.source) === 'offer' && m ? Number(m[1]) : null; };
